// extracted by mini-css-extract-plugin
export default {"content":"HxqiYjaFvKb5cEJB9JjI","text":"wioD1zU_XMFLXilRAUIU","buttons":"veKZXPTlkalpENGrnkIP","placeHolderShimmer":"IhrtUfbaDDSYVp8TfDSL"};